import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'material-ui/Checkbox';

import Subheader from '../subheader';
import Search from '../search';

const isCheckboxDisabled = (error, pending) => error !== '' && !pending;

const Header = ({
  chunks,
  error,
  pending,
  title,
  filter,
  onChange,
  selectAll,
  onSelectAllResponses,
  onDeselectAllResponses,
  actionMenu,
  dataFilters,
}) => {
  const hasData = chunks && Object.keys(chunks).length;
  return (
    <div className="row middle-xs">
      <div className={dataFilters ? 'col-xs-3' : 'col-xs-2'}>
        <Subheader title={title} />
      </div>

      <div className="col-xs-8 row">
        <div className={dataFilters ? 'col-xs-8' : 'col-xs-10'}>
          <Search
            name="search"
            placeholder="Search..."
            value={filter}
            onChange={val => onChange(val)}
            onClear={() => onChange('')}
          />
        </div>
        <div className={dataFilters ? 'col-xs-1' : 'col-xs-3'}>
          {dataFilters}
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  error: PropTypes.string,
  pending: PropTypes.bool.isRequired,
  title: PropTypes.element.isRequired,
  filter: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selectAll: PropTypes.bool,
  onSelectAllResponses: PropTypes.func,
  onDeselectAllResponses: PropTypes.func,
  actionMenu: PropTypes.element,
  dataFilters: PropTypes.element,
};

Header.defaultProps = {
  actionMenu: null,
  error: '',
  selectAll: false,
  dataFilters: null,
  filter: null,
  onSelectAllResponses: null,
  onDeselectAllResponses: null,
};

export default Header;
